import { render, staticRenderFns } from "./ListClaim.vue?vue&type=template&id=6e14d85b&scoped=true&"
import script from "./ListClaim.vue?vue&type=script&lang=js&"
export * from "./ListClaim.vue?vue&type=script&lang=js&"
import style0 from "./ListClaim.vue?vue&type=style&index=0&id=6e14d85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e14d85b",
  null
  
)

export default component.exports